import * as yup from 'yup'
import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Button, ModalFooter, useDisclosure, Stack, Flex } from '@chakra-ui/react';
import { Save } from '../icons';
import { Step2FormValues } from './chaloupka/Step2Form';
import { FormProvider, useForm } from 'react-hook-form';
import { useInsuranceParamsContext } from '../layouts/Wizard';
import { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos';
import { PaymentFrequency } from './PaymentFrequency';
import { ExtraInsuranceProperty } from './ExtraInsuranceProperty';
import { useSaveStep2 } from '../hooks/useWizard';
import { AxiosError } from 'axios';
import SubmitDialog from 'BrokerTsLib/src/components/SubmitDialog';
import ErrorSummary from '../components/ErrorSummary';
import * as global from 'brokertslib/src/helpers/global'
import { yupResolver } from '@hookform/resolvers/yup';
import { usePropertyOffersContext } from '../context/PropertyOffersProvider';

export const ExtraInsurancePropertyModal = ({
    isOpen = false,
    onClose,
}: {
    isOpen: boolean
    onClose: () => void
}) => {
    const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams } = useInsuranceParamsContext()
    const { mutateAsync: submitForm, isError: isSubmitError } = useSaveStep2()
    const { offers, recalculateOffers } = usePropertyOffersContext()

    const {
        isOpen: isSavedFormAlertOpen,
        onOpen: savedFormAlertOnOpen,
        onClose: savedFormAlertOnClose,
    } = useDisclosure()

    const methods = useForm<Step2FormValues>({
        resolver: yupResolver(yup.object().shape({})) as any, // aby se pripadne resetovaly serverove validace
        mode: 'onBlur',
        defaultValues: {
            property: (insuranceParams as InsuranceParamsPropertyDto).property
        },
    })

    const {
        handleSubmit,
        setError,
        formState: { errors }
    } = methods

    const handlePostError = (data: any) => {
        Object.keys(data).forEach((x: any) => {
            if (x.toString().toLowerCase().startsWith('discounts[')) {
                setError(x.toLowerCase(), { message: data[x].join(' ') })
            } else {
                setError(global.toCamelCase(x), { message: data[x].join(' ') })
            }
        })
    }

    const onSubmitForm = handleSubmit((data) => {
        return submitForm({ ...data, paramsId: paramsId ?? "" })
            .then((response) => {
                refetchInsuranceParams()
                recalculateOffers()
                savedFormAlertOnOpen()
            })
            .catch((err: AxiosError) => {
                if (!(err.response && err.response.status === 400 && err.response.data)) {
                    savedFormAlertOnOpen()
                    return;
                }

                let data = err.response.data
                handlePostError(data);
            })
            .finally(() => { })
    })

    return (
        <>
            <Modal size="6xl" onClose={onClose} isOpen={isOpen}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Nastavení parametrů pro všechny nabídky</ModalHeader>
                    <ModalBody>
                        <Box sx={{ display: 'grid', gap: 8, justifyContent: 'start' }}>
                            <FormProvider {...methods}>
                                <form onSubmit={onSubmitForm}>
                                    <Box sx={{ display: 'grid', gap: 8 }}>
                                        {/* <PaymentFrequency />
                                        <ExtraInsuranceProperty showIcons={false} /> */}

                                        <ExtraInsuranceProperty />
                                    </Box>
                                </form>
                            </FormProvider>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Stack w='100%' alignItems='end'>
                            <Box>
                                <Button
                                    colorScheme="primary"
                                    onClick={() => {
                                        onSubmitForm()
                                    }}
                                >
                                    <Save />
                                    Uložit a přepočítat
                                </Button>
                            </Box>

                            <ErrorSummary errors={errors} />
                        </Stack>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <SubmitDialog
                isOpen={isSavedFormAlertOpen}
                onClose={() => {
                    savedFormAlertOnClose()

                    if (!isSubmitError)
                        onClose()
                }}
                colorScheme={!isSubmitError ? 'primary' : "red"}
                header={!isSubmitError ? 'Uloženo' : "Chyba"}
                body={!isSubmitError ? 'Parametry nabídky byly úspěšně uloženy' : "Při ukládání došlo k chybě"}
            />
        </>
    );
};
